export default "__VITE_ASSET__b78df655__"